export { Separator } from './Separator'
export type { SeparatorProps } from './Separator'
